import React, { PropTypes, Component } from 'react';
import moment from 'moment';
import R from 'ramda';
import { RadioButton, RadioButtonGroup, SelectField, MenuItem } from 'material-ui';
import TcDayPicker from './date-picker';


const currentYear = new Date().getFullYear();
let subOptionsMap = {
  calendarYear: [{
    label: `01 Jan ${currentYear} - 31 Dec ${currentYear}`,
    value: `${currentYear}-01-01T00:00:00.000Z|${currentYear}-12-31T00:00:00.000Z`,
    period: {
      startDate: `${currentYear}-01-01T00:00:00.000Z`,
      endDate: `${currentYear}-12-31T00:00:00.000Z`,
    },
  },
    {
      label: `01 Jan ${currentYear + 1} - 31 Dec ${currentYear + 1}`,
      value: `${currentYear + 1}-01-01T00:00:00.000Z|${currentYear + 1}-12-31T00:00:00.000Z`,
      period: {
        startDate: `${currentYear + 1}-01-01T00:00:00.000Z`,
        endDate: `${currentYear + 1}-12-31T00:00:00.000Z`,
      },
    },
    {
      label: `01 Jan ${currentYear + 2} - 31 Dec ${currentYear + 2}`,
      value: `${currentYear + 2}-01-01T00:00:00.000Z|${currentYear + 2}-12-31T00:00:00.000Z`,
      period: {
        startDate: `${currentYear + 2}-01-01T00:00:00.000Z`,
        endDate: `${currentYear + 2}-12-31T00:00:00.000Z`,
      },
    }],
  firstHalf: [{
    label: `01 Jan ${currentYear} - 30 Jun ${currentYear}`,
    value: `${currentYear}-01-01T00:00:00.000Z|${currentYear}-06-30T00:00:00.000Z`,
    period: {
      startDate: `${currentYear}-01-01T00:00:00.000Z`,
      endDate: `${currentYear}-06-30T00:00:00.000Z`,
    },
  },
    {
      label: `01 Jan ${currentYear + 1} - 30 Jun ${currentYear + 1}`,
      value: `${currentYear + 1}-01-01T00:00:00.000Z|${currentYear + 1}-06-30T00:00:00.000Z`,
      period: {
        startDate: `${currentYear + 1}-01-01T00:00:00.000Z`,
        endDate: `${currentYear + 1}-06-30T00:00:00.000Z`,
      },
    },
    {
      label: `01 Jan ${currentYear + 2} - 30 Jun ${currentYear + 2}`,
      value: `${currentYear + 2}-01-01T00:00:00.000Z|${currentYear + 2}-06-30T00:00:00.000Z`,
      period: {
        startDate: `${currentYear + 2}-01-01T00:00:00.000Z`,
        endDate: `${currentYear + 2}-06-30T00:00:00.000Z`,
      },
    }],
  secondHalf: [{
    label: `01 Jul ${currentYear} - 31 Dec ${currentYear}`,
    value: `${currentYear}-07-01T00:00:00.000Z|${currentYear}-12-31T00:00:00.000Z`,
    period: {
      startDate: `${currentYear}-07-01T00:00:00.000Z`,
      endDate: `${currentYear}-12-31T00:00:00.000Z`,
    },
  },
    {
      label: `01 Jul ${currentYear + 1} - 31 Dec ${currentYear + 1}`,
      value: `${currentYear + 1}-07-01T00:00:00.000Z|${currentYear + 1}-12-31T00:00:00.000Z`,
      period: {
        startDate: `${currentYear + 1}-07-01T00:00:00.000Z`,
        endDate: `${currentYear + 1}-12-31T00:00:00.000Z`,
      },
    },
    {
      label: `01 Jul ${currentYear + 2} - 31 Dec ${currentYear + 2}`,
      value: `${currentYear + 2}-07-01T00:00:00.000Z|${currentYear + 2}-12-31T00:00:00.000Z`,
      period: {
        startDate: `${currentYear + 2}-07-01T00:00:00.000Z`,
        endDate: `${currentYear + 2}-12-31T00:00:00.000Z`,
      },
    }],
  aprMar: [{
    label: `01 Apr ${currentYear} - 31 Mar ${currentYear + 1}`,
    value: `${currentYear}-04-01T00:00:00.000Z|${currentYear + 1}-03-31T00:00:00.000Z`,
    period: {
      startDate: `${currentYear}-04-01T00:00:00.000Z`,
      endDate: `${currentYear + 1}-03-31T00:00:00.000Z`,
    },
  },
    {
      label: `01 Apr ${currentYear + 1} - 31 Mar ${currentYear + 2}`,
      value: `${currentYear + 1}-04-01T00:00:00.000Z|${currentYear + 2}-03-31T00:00:00.000Z`,
      period: {
        startDate: `${currentYear + 1}-04-01T00:00:00.000Z`,
        endDate: `${currentYear + 2}-03-31T00:00:00.000Z`,
      },
    },
    {
      label: `01 Apr ${currentYear + 2} - 31 Mar ${currentYear + 3}`,
      value: `${currentYear + 2}-04-01T00:00:00.000Z|${currentYear + 3}-03-31T00:00:00.000Z`,
      period: {
        startDate: `${currentYear + 2}-04-01T00:00:00.000Z`,
        endDate: `${currentYear + 3}-03-31T00:00:00.000Z`,
      },
    }],
  octSep: [{
    label: `01 Oct ${currentYear} - 30 Sep ${currentYear + 1}`,
    value: `${currentYear}-10-01T00:00:00.000Z|${currentYear + 1}-09-30T00:00:00.000Z`,
    period: {
      startDate: `${currentYear}-10-01T00:00:00.000Z`,
      endDate: `${currentYear + 1}-09-30T00:00:00.000Z`,
    },
  },
    {
      label: `01 Oct ${currentYear + 1} - 30 Sep ${currentYear + 2}`,
      value: `${currentYear + 1}-10-01T00:00:00.000Z|${currentYear + 2}-09-30T00:00:00.000Z`,
      period: {
        startDate: `${currentYear + 1}-10-01T00:00:00.000Z`,
        endDate: `${currentYear + 2}-09-30T00:00:00.000Z`,
      },
    },
    {
      label: `01 Oct ${currentYear + 2} - 30 Sep ${currentYear + 3}`,
      value: `${currentYear + 2}-10-01T00:00:00.000Z|${currentYear + 3}-09-30T00:00:00.000Z`,
      period: {
        startDate: `${currentYear + 2}-10-01T00:00:00.000Z`,
        endDate: `${currentYear + 3}-09-30T00:00:00.000Z`,
      },
    }],
};
const options = [
  { label: 'Calendar Year', value: 'calendarYear' },
  { label: '1st Half of Year', value: 'firstHalf' },
  { label: '2nd Half of Year', value: 'secondHalf' },
  { label: '01 Apr - 31 Mar', value: 'aprMar' },
  { label: '01 Oct - 30 Sep', value: 'octSep' },
  { label: 'Custom date range', value: 'other' },
];

const getOptionFromDate = (startDate, endDate) => {
  if (
    moment.utc(startDate).toISOString().indexOf('-01-01') > -1
    && moment.utc(endDate).toISOString().indexOf('-12-31') > -1
  ) {
    return 'calendarYear';
  }
  if (
    moment.utc(startDate).toISOString().indexOf('-01-01') > -1
    && moment.utc(endDate).toISOString().indexOf('-06-30') > -1
  ) {
    return 'firstHalf';
  }
  if (
    moment.utc(startDate).toISOString().indexOf('-07-01') > -1
    && moment.utc(endDate).toISOString().indexOf('-12-31') > -1
  ) {
    return 'secondHalf';
  }
  if (
    moment.utc(startDate).toISOString().indexOf('-04-01') > -1
    && moment.utc(endDate).toISOString().indexOf('-03-31') > -1
  ) {
    return 'aprMar';
  }
  if (
    moment.utc(startDate).toISOString().indexOf('-10-01') > -1
    && moment.utc(endDate).toISOString().indexOf('-09-30') > -1
  ) {
    return 'octSep';
  }
  return 'other';
};
class ContractingPeriodSelection extends Component {
  constructor(props) {
    super(props);
    const period = { startDate: props.startDate, endDate: props.endDate };
    const stringValue = props.startDate ? `${moment.utc(props.startDate).toISOString()}|${moment.utc(props.endDate).toISOString()}` : '';
    const mainOptionValue = props.startDate ? getOptionFromDate(props.startDate, props.endDate) : '';
    this.state = {
      fromProps: {
        period,
        stringValue,
        mainOptionValue,
      },
      period,
      stringValue,
      mainOptionValue,
    };
  }

  onMainOptionSelectionChange = (e, i, value) => {
    this.setState({ mainOptionValue: value, period: {}, stringValue: '' }, () => {
      this.props.onChange({});
    });
  };
  onSelectionChange = (_, value) => {
    const period = {
      startDate: value.split('|')[0],
      endDate: value.split('|')[1],
    };
    this.setState({ period, stringValue: value });
    this.props.onChange(period);
  };
  onStartDateTFChange = (date) => {
    const { endDate } = this.state.period;
    if (endDate) this.props.onChange({ startDate: date, endDate });
    this.setState({ period: { startDate: date, endDate } });
  };
  onEndDateTFChange = (date) => {
    const { startDate } = this.state.period;
    if (startDate) this.props.onChange({ startDate, endDate: date });
    this.setState({ period: { startDate, endDate: date } });
  };
  render() {
    const { fromProps, period, stringValue, mainOptionValue } = this.state;
    const { startDate, endDate } = period;
    let subOptions = subOptionsMap[mainOptionValue] || [];
    const isInTheHardCodedList = fromProps.mainOptionValue === 'other'
      || subOptions.find(obj => obj.value === fromProps.stringValue);
    if (!isInTheHardCodedList && fromProps.mainOptionValue === mainOptionValue) {
      subOptions = [
        {
          label: `${
            moment.utc(fromProps.period.startDate).format('DD MMM YYYY')
          } - ${moment.utc(fromProps.period.endDate).format('DD MMM YYYY')}`,
          value: fromProps.stringValue,
          period: fromProps.period,
        },
        ...subOptions,
      ];
    }
    subOptions = R.uniqBy(
      R.prop('value'),
      subOptions
    );
    return (
      <div style={this.props.style}>
        <SelectField
          hintText="Click to Pick An Option"
          data-cy="dateRangeSelection"
          value={mainOptionValue}
          onChange={this.onMainOptionSelectionChange}
        >
          {
            options.map(option => {
              return (
                <MenuItem
                  key={option.value}
                  data-cy={option.label}
                  primaryText={option.label}
                  value={option.value}
                />
              );
            })
          }
        </SelectField>
        {
          mainOptionValue && mainOptionValue !== 'other' && (
            <div style={{ marginBottom: '16px' }}>
              Select A Date Range
              <br/>
              <RadioButtonGroup
                name="dateRangeSelection"
                valueSelected={stringValue}
                onChange={this.onSelectionChange}
              >
              {
                subOptions.map((option, i) => {
                  return (
                    <RadioButton
                      key={option.label}
                      label={option.label}
                      value={option.value}
                    />
                  );
                })
              }
              </RadioButtonGroup>
            </div>
          )
        }
        {
          mainOptionValue === 'other' && (
            <div style={{ marginBottom: '16px' }}>
              <TcDayPicker
                data-cy="templateStartDateField"
                containerStyle={{ display: 'inline-block', verticalAlign: 'top' }}
                textFieldStyle={{ width: '100%', fontSize: '12px' }}
                onChange={this.onStartDateTFChange}
                initialMonth={startDate || endDate}
                value={startDate}
                floatingLabelText="Start Date"
                closeOnSelect
              />
              <TcDayPicker
                data-cy="templateEndDateField"
                containerStyle={{ display: 'inline-block', marginLeft: '32px', verticalAlign: 'top' }}
                textFieldStyle={{ width: '100%', fontSize: '12px' }}
                onChange={this.onEndDateTFChange}
                initialMonth={endDate || startDate}
                value={endDate}
                floatingLabelText="End Date"
                closeOnSelect
              />
            </div>
          )
        }
      </div>
    );
  }
}

ContractingPeriodSelection.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  style: PropTypes.object,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
};
export default ContractingPeriodSelection;



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/contractingPeriodsSelection.jsx